var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vittles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vittles-4e",
    transform: "translate(-220.000000, -490.000000)",
    fill: "#FFDB00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-9",
    transform: "translate(25.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(57.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(36.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-icon",
    transform: "translate(102.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.787663,2.39276238 C12.3399478,2.39276238 12.787663,2.84047763 12.787663,3.39276238 L12.787663,13.3927624 C12.787663,13.9450471 12.3399478,14.3927624 11.787663,14.3927624 L3.78766301,14.3927624 C3.23537826,14.3927624 2.78766301,13.9450471 2.78766301,13.3927624 L2.78766301,3.39276238 C2.78766301,2.84047763 3.23537826,2.39276238 3.78766301,2.39276238 L11.787663,2.39276238 Z M11.287663,3.89276238 L4.28766301,3.89276238 L4.28766301,12.8927624 L11.287663,12.8927624 L11.287663,3.89276238 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44225222,-2.25597319e-13 L9.44225222,1.5 L1.75,1.5 C1.63165327,1.5 1.53251318,1.58223341 1.50660268,1.69267729 L1.5,1.75 L1.5,10.8653036 L0,10.8653036 L0,1.75 C0,0.831826603 0.707110273,0.0788076603 1.60647279,0.00580119953 L1.75,-2.25597319e-13 L9.44225222,-2.25597319e-13 Z",
    id: "Path-6"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bf0279b06387774fdfdec746de5327b1.svg";
export { ForwardRef as ReactComponent };